(function () {
"use strict";
var BUY = "/#tarifs";
var OPEN = /^#?(accueil|modules|module-1|voeux)?$/;
var CSS = ".demo-bar{background:#16193A;color:#fff;font-size:.82rem;line-height:1.4;padding:9px 16px;text-align:center}" +
".demo-bar a{color:#FFD166;font-weight:700}" +
".demo-chip{background:var(--marker);color:#16193A;font-weight:700;font-size:.75rem;padding:6px 12px;border-radius:999px;text-decoration:none;white-space:nowrap}" +
".demo-up ul{margin:0;padding-left:1.15em;display:flex;flex-direction:column;gap:4px}" +
".demo-up .row{gap:10px}";
var st = document.createElement("style"); st.textContent = CSS; document.head.appendChild(st);
function title(h) {
var m = h.match(/^#module-(\d+)/); if (m) return "Le module " + m[1] + " est dans le Kit";
var t = { lettres: "L'atelier lettre est dans le Kit", lettre: "L'atelier lettre est dans le Kit", indices: "L'atelier « Mes indices » est dans le Kit",
calendrier: "Le calendrier avec rappels est dans le Kit", checklist: "La checklist de confirmation est dans le Kit",
scenarios: "Les scénarios de juin sont dans le Kit", plus: "Les ressources et la sauvegarde sont dans le Kit" };
var k = h.replace(/^#/, "").split("-")[0];
return t[k] || "Cette partie est dans le Kit";
}
function upsell(h) {
return '<section class="panel demo-up"><p class="eyebrow">Aperçu gratuit</p><h1 style="font-size:var(--t-xl)">' + title(h) + "</h1>" +
'<p class="small muted">Tu utilises l\'aperçu gratuit : le module 1 et « Mes vœux » sont ouverts. Le Kit complet débloque tout le reste, et tu retrouves les vœux que tu as déjà saisis.</p>' +
'<ul class="small"><li>Les 8 modules, chacun avec sa vidéo et son quiz</li><li>L\'atelier lettre avec la méthode FIL, le compteur et la grille en 12 points</li>' +
"<li>Le calendrier avec rappels et le plan mois par mois</li><li>La checklist de confirmation et les 4 scénarios de juin</li><li>Le guide des parents et la version imprimable</li></ul>" +
'<div class="row wrap"><a class="btn pri" href="' + BUY + '">Débloquer le Kit · 29 €</a><a class="btn" href="#module-1">Revenir au module 1</a></div>' +
'<p class="xs muted">Paiement unique · accès immédiat · 14 jours pour changer d\'avis</p></section>';
}
var app = document.getElementById("app");
function guard() {
var main = document.getElementById("main"); if (!main) return;
var tag = document.querySelector(".top-in > span.xs.muted");
if (tag) { var a = document.createElement("a"); a.className = "demo-chip"; a.href = BUY; a.textContent = "Débloquer · 29 €"; tag.parentNode.replaceChild(a, tag); }
var h = location.hash || "";
if (OPEN.test(h)) {
Array.prototype.forEach.call(document.querySelectorAll('.mods a[href^="#module-"]'), function (el) {
if (el.getAttribute("href") !== "#module-1") { var m = el.querySelector(".m"); if (m) m.textContent = "Dans le Kit"; }
});
return;
}
main.innerHTML = upsell(h);
}
if (app && window.MutationObserver) new MutationObserver(guard).observe(app, { childList: true });
guard();
})();
